import { render, staticRenderFns } from "./view-uom-product.vue?vue&type=template&id=f1e1ed8c"
import script from "./view-uom-product.vue?vue&type=script&lang=js"
export * from "./view-uom-product.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports